import { cn } from '../../lib/cn'
import type { SituacaoDaOs } from '../../types/ordemDeServico'
import { descricaoDaSituacao } from './situacaoDaOs'

const BASE =
  'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset'

/**
 * A situação da ordem, com de quem se está esperando logo abaixo.
 *
 * As duas informações andam juntas porque respondem a perguntas diferentes, e é a segunda que
 * destrava o processo: "aguardando recebimento provisório" diz o quê, "esperando: a Prefeitura" diz
 * de quem — e numa tela que também mostra glosa, deixar isso implícito faz o atraso do Município
 * parecer atraso da contratada.
 *
 * @param props a situação projetada e se o "esperando" deve aparecer
 * @returns a etiqueta
 */
export function SeloDaSituacao({ situacao, comEspera }: { situacao: SituacaoDaOs; comEspera?: boolean }) {
  const descricao = descricaoDaSituacao(situacao)
  return (
    <span className="inline-flex flex-col items-start gap-0.5">
      <span className={cn(BASE, descricao.cor)} title={descricao.ajuda}>
        {descricao.rotulo}
      </span>
      {comEspera && <span className="text-xs text-slate-500">Esperando: {descricao.esperando}</span>}
    </span>
  )
}
